import { 
    Container,
    Box,
    Typography, 
} from "@mui/material";

const PolicyContainer = ({ title, body }) => {
    return (
        <Container sx={{ height: '100%', mb: 10, mt: 12 }}>
            <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', gap: 10}}>
                <Typography variant="h4" component="h1" sx={{alignSelf: 'center', fontWeight: 'bold'}}>
                    {title}
                </Typography>
                <Typography variant="h6" component="p" sx={{color: 'inherit'}}>
                    {body}
                </Typography>
            </Box>
        </Container>
    );
}

export default PolicyContainer;